
<template>
  <div
    class="m-map"
    v-loading="loading"
    element-loading-text="正在加载，请稍等..."
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <template v-if="isLoadAllData">
      <hotCity
        :isSelectCode="isSelectCode"
        ref="hotCity"
        v-if="isHotCity"
        @returnCityData="returnCityData"
      />
      <p class="m-font0" v-if="isShowHotData && !isHotCity">
        {{hotZoneAreas[0].cityName}}为热门城市，
        <span @click="isShowHotFun">查看更多数据>></span>
      </p>
      <div class="home">
        <img width="24" @click="goHome" src="../../../assets/images/icon_home.png" />
      </div>
      <!-- 左侧数据 -->
      <leftData
        :leftIndex="leftIndex"
        :btnIndex="roadType"
        @isShowList="isShowList"
        ref="left"
        :isHotCity="isHotCity"
        @changeLeftIndex="changeLeftIndex"
        @initData="initData"
        :hotZoneAreas="hotZoneAreas"
        :leftData="leftData"
      />
      <!-- 全国道路右侧详情 -->
      <rightData
        v-if="showRightData && !isHotCity"
        :clickId="clickId"
        :hidedata="hidedata"
        :listDataRi="listDataRi"
        :loadingRight="loadingRight"
        :itemData="objData"
      />
      <!-- 右侧热门城市详情 -->
      <cityRightData
        v-if="showRightData && isHotCity"
        :chartData="chartData"
        :hidedata="hidedata"
        :heightName="heightName"
        :loadingRight="loadingRight"
      />
      <!-- 地图 -->
      <mapDrag
        :allData="allData"
        :leftIndex="leftIndex"
        :listDatas="leftDatePath"
        :lnglats="lnglats"
        :hidedata="hidedata"
        :showRightData="showRightData"
        :pathData="pathData"
        :hCityDetails="hCityDetails"
        :hotZoneAreas="hotZoneAreas"
        :isDblClickM="isDblClickM"
        ref="mapDrag"
        :isAutoSet="isAutoSet"
        :isHotCity="isHotCity"
        :clickId="clickId"
        :isShowHotCity="isShowHotCity"
        @changeLeftIndex="changeLeftIndex"
        @getHCityDetails="getHCityDetails"
        @showNewPos="showNewPos"
      ></mapDrag>
      <!-- 新增站点弹框 -->
      <newPos
        v-if="isShowNewPos"
        :formLabelAlign="formLabelAlign"
        :nLeft="nLeft"
        :nTop="nTop"
        :isAdd="isAdd"
        @giveUp="giveUp"
        @confirmAddSite="confirmAddSite"
      />
    </template>
  </div>
</template>
<script>
import axios from '@/api/road.js'
import mapDrag from '../mapComponents/mapDrag.vue'
import newPos from '../mapComponents/newPos.vue'
import leftData from './leftData.vue'
import rightData from './rightData.vue'
import cityRightData from './cityRightData.vue'
import hotCity from '../mapComponents/hotCity.vue'
import commonFun from '../assets/js/common.js'
export default {
  components: {
    mapDrag,
    hotCity,
    cityRightData,
    leftData,
    rightData,
    newPos
  },
  data() {
    return {
      loading: false,
      heightName: '',
      isSelectCode: '',
      loadingRight: false,
      hidedata: false,
      dragStatus: false,
      AMapUI: null,
      isHome: false, //非首页
      AMap: null,
      leftIndex: null,
      showRightData: false,
      chartData: [], //热门城市详情
      leftDatePath: [], //画线数组
      isShowNewPos: false, //是否显示添加站点
      isLoadAllData: false,
      allData: {},
      // 右侧详情
      objData: {},
      // 站点参数
      isAdd: true,
      nLeft: 0,
      nTop: 0,
      formLabelAlign: {},
      clickId: 0,
      roadType: '全部',
      lnglats: [],
      isDblClickM: false, //是否取消操作站点
      hCityDetails: [], //鼠标放上去展示热区详情
      hotZoneAreas: [],
      cityCode: '',
      cityDataObj: {}, //热门城市
      isShowHotCity: true,
      roadIds: [],
      isshowAllRoad: false, //全部加载
      pIndex: 0,
      isHotCity: false,
      isShowHotData: false,
      pathData: [], //全部加载分批
      allPaths: [], //全部道路
      roadSArea: [], //某条道路
      roadLen: 0
    }
  },
  props: {
    searchKeyVal: String,
    lat: Number,
    lng: Number,
    mapCityName: String,
    mapCityCode: String
  },
  watch: {},
  created() {
     clearInterval(this.isFinish)
    // console.log(mapCityName, mapCityCode)
    // this.cityCode = mapCityCode
    // this.isHotCity = false
    this.cityCode = this.$route.query.cityCode
    this.isSelectCode = this.$route.query.cityCode
    this.isHotCity =
      this.$route.query.isHotCity === false ||
      this.$route.query.isHotCity === 'false'
        ? false
        : true
    var _this = this
    if (!this.isHotCity) {
      axios.getTop20City().then(e => {
        if ((e.code = 200)) {
          var data = e.data
          for (var v of data) {
            if (v.cityCode == _this.cityCode) {
              _this.isShowHotData = true
              _this.isSelectCode = v.cityCode
            }
          }
        }
      })
    }

    this.cityDataObj.cityName = this.$route.query.cityName
    this.hotZoneAreas = [
      { cityName: this.$route.query.cityName, cityCode: this.cityCode }
    ]
    this.initData(this.roadType, true)
  },
  mounted() {
    this.pIndex = 0
    this.isshowAllRoad = false
    var _this = this
  },
  methods: {
    // 全部道路
    loadMorePath() {
      this.isshowAllRoad = true
      var leftDataId = this.leftDataId
      var pIndex = this.pIndex
      if (leftDataId.length == 0) {
        return
      }
      this.roadIds = leftDataId.splice(0, 5)
      this.pIndex = pIndex + 1
      this.initData(this.roadType, false)
    },
    // 初始化地图
    initData(roadType, isFirst) {
      let _this = this
      _this.loading = true
      _this.showRightData = false
      if (isFirst) {
        this.leftData = []
        this.clickId = 0
        this.leftDatePath = []
        _this.allPaths = []
        this.isAutoSet = false
      }
      this.roadType = roadType
      var data = {
        roadType: _this.roadType == '全部' ? null : _this.roadType,
        cityCode: _this.cityCode,
        roadIds: isFirst ? null : _this.roadIds
      }
      if (!this.isHotCity) {
        data.isCompressed = false
      }
      axios.getTop30CityRoad(data, this.isHotCity).then(e => {
        if (isFirst) {
          _this.allData = e.data
          var leftData = commonFun.returnColor(_this.allData.leftData, true) //左侧数据
          var leftDataId = []
          for (var v of leftData) {
            leftDataId.push(v.id)
          }
          _this.leftDataId = leftDataId
          _this.leftData = [...leftData]
          _this.roadLen = Math.ceil(this.leftData.length / 5)
          // _this.roadLen = 1
          _this.isFinish = setInterval(function() {
            // console.log(_this.$refs.mapDrag.isFinishMap)
            if (_this.$refs.mapDrag.isFinishMap) {
              // 是否是全部道路加载进来
              _this.loadMorePath()
              clearInterval(_this.isFinish)
            }
          }, 500)
          setTimeout(function() {
            _this.getSiteList()
          }, 3000)
        } else {
          if (_this.isshowAllRoad) {
            _this.pathData = [...e.data.leftData]
            var data = _this.allPaths.concat(e.data.leftData)
            _this.allPaths = [...data]
            if (_this.pIndex == _this.roadLen) {
              _this.isshowAllRoad = false
              _this.pIndex = 0
              _this.loading = false
              return
            } else {
              // 加载全部
              _this.loadMorePath()
            }
          } else {
            // 判断是否有道路数据
            var isHaveData = _this.$refs.mapDrag.changeLsData(e.data.leftData)
            if (isHaveData.length == 0) {
              this.$message({
                message: '暂无相关道路信息',
                type: 'warning',
                duration: 3000,
                showClose: true
              })
            }

            _this.leftDatePath = [..._this.allPaths]
          }
        }
        _this.isLoadAllData = true
        _this.loading = false
      })
    },
    isShowHotFun() {
      this.isHotCity = true
      this.initData(this.roadType, true)
    },
    goHome() {
      this.isHotCity = true
      this.$router.push({ path: '/roadOperation/allRoad' })
    },
    // 获取站点
    getSiteList() {
      var _this = this
      axios.getListSide({ cityName: _this.cityDataObj.cityName }).then(e => {
        if (e.code == 200) {
          if (e.data) {
            _this.lnglats = [...e.data]
          }
        }
      })
    },
    // 路线和左侧数据关联得ID
    changeLeftIndex(id, name) {
      var _this = this
      this.clickId = id
      this.isAutoSet = true
      this.roadIds = [id]
      var arr = this.leftData
      for (var k = 0; k < arr.length; k++) {
        if (arr[k].id == id) {
          _this.heightName = arr[k].highSpeedName
          _this.$refs.left.changeTop(k)
          arr[k].isShow = true
        } else {
          arr[k].isShow = false
        }
      }
      this.hCityDetails = []
      // _this.leftDatePath = [..._this.allPaths]
      this.initData(this.roadType, false)
      _this.leftData = [...arr]
      if (this.isHotCity) {
        axios
          .getAllRoadCity(
            id,
            _this.cityDataObj.cityName ? _this.cityDataObj.cityName : null
          )
          .then(e => {
            if (e.code == 200) {
              if (e.data) {
                var data = e.data[0].data
                var newData = []
                for (var v of data) {
                  for (var i in v) {
                    newData.push({ name: i, value: v[i] })
                  }
                }
                e.data[0].newData = newData
                _this.chartData = [...e.data]
                _this.showRightData = true
                _this.loadingRight = false
              } else {
                this.$message({
                  message: '暂无相关道路信息',
                  type: 'warning',
                  duration: 3000,
                  showClose: true
                })
              }
            }
          })
      } else {
        axios.getRoadDetails(id, this.hotZoneAreas[0].cityName).then(e => {
          if (e.code == 200) {
            if (e.data) {
              _this.objData = e.data
              if (e.data.listData) {
                _this.listDataRi = [...e.data.listData]
                _this.showRightData = true
                _this.loadingRight = false
              } else {
                this.$message({
                  message: '暂无相关道路信息',
                  type: 'warning',
                  duration: 3000,
                  showClose: true
                })
              }
            }
          }
        })
      }
    },
    confirmAddSite() {
      this.getSiteList()
      this.isDblClickM = false
      this.isShowNewPos = false
    },
    // 取消添加站点
    giveUp() {
      if (this.isAdd) {
        var lnglats = this.lnglats
        lnglats.pop()
        this.lnglats = [...lnglats]
      } else {
        this.getSiteList()
      }

      this.$refs.mapDrag.isDblClickM = false
      this.$refs.mapDrag.hideClickDetails = false
      this.isDblClickM = false
      this.isShowNewPos = false
    },
    showNewPos(e, isAdd, obj) {
      var ww = document.body.clientWidth - 348
      var wh = document.body.clientHeight - 360
      var x = e.x
      var y = e.y
      if (x > ww) {
        x = x - 348
      }
      if (y > wh) {
        y = y - 360
      }
      this.nLeft = x
      this.nTop = y
      this.isAdd = isAdd
      this.formLabelAlign = obj
      this.isShowNewPos = true
    },
    // 鼠标放上去获取城市运营详情
    getHCityDetails(name, id) {
      var _this = this
      var leftData = this.leftData
      var hName = null
      for (var v of leftData) {
        if (v.id == id) {
          hName = v.highSpeedName
        }
      }
      if (this.isHotCity) {
        axios
          .getAllRoadCity(
            id,
            _this.cityDataObj.cityName ? _this.cityDataObj.cityName : null
          )
          .then(e => {
            if (e.code == 200) {
              if (e.data.length > 0) {
                var data = e.data
                data[0].highSpeedName = hName
                data[0].operations = data[0].dayOperate
                _this.hCityDetails = [...e.data]
              }
            }
          })
      } else {
        axios
          .getRoadDetails(
            id,
            _this.cityDataObj.cityName ? _this.cityDataObj.cityName : null
          )
          .then(e => {
            if (e.code == 200) {
              var data = e.data.listData
              data[0].highSpeedName = hName
              _this.hCityDetails = [...data]
            }
          })
      }
    },
    // 热门城市数据
    returnCityData(obj) {
      this.cityDataObj = obj
      this.cityCode = obj.cityCode
      this.isSelectCode = obj.cityCode
      this.isShowHotCity = true
      this.showRightData = false
      this.isshowAllRoad = true
      this.pathData = [...[]]
      this.leftDatePath = [...[]]
      this.allPaths = [...[]]
      this.hotZoneAreas = [
        ...[{ cityName: obj.cityName, cityCode: obj.cityCode }]
      ]
      // 初始化地图
      this.$refs.mapDrag.clearAllPath()
      this.$refs.mapDrag.clearAllSite()

      this.initData(this.roadType, true)
    },
    // 是否隐藏两侧
    isShowList(e) {
      this.hidedata = e
    }
  }
}
</script>
<style>
.home {
  width: 55px;
  height: 57px;
  background: #444a67;
  border-radius: 2px;
  position: absolute;
  left: 15px;
  line-height: 70px;
  text-align: center;
  z-index: 100;
  top: 15px;
  cursor: pointer;
}

.road-operation-main {
  padding: 0 !important;
  overflow: hidden;
}
.m-map,
#js-container {
  width: 100%;
  height: 100%;
  min-height: 600px;
  position: relative;
}
button:hover {
  cursor: pointer;
}
.el-loading-mask {
  z-index: 999 !important;
}
.sName {
  margin-left: 10px;
}
</style>